// ============================================================================
// NOTIFICATION ENDPOINTS
// ============================================================================
// URL builders for the in-app inbox proxy.
// Backend controller: NotificationsController → /api/v1/notifications/inbox*

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';

const BASE_PATH = '/notifications/inbox';

export const notificationEndpoints = {
  /** GET /api/v1/notifications/inbox?page=&pageSize=&unreadOnly= */
  inbox: () => buildEndpoint(BASE_PATH),

  /** GET /api/v1/notifications/inbox/unread-count */
  unreadCount: () => buildEndpoint(`${BASE_PATH}/unread-count`),

  /** POST /api/v1/notifications/inbox/mark-read */
  markRead: () => buildEndpoint(`${BASE_PATH}/mark-read`),

  /** POST /api/v1/notifications/inbox/{channelId}/archive */
  archive: (channelId: string) =>
    buildEndpointWithParams(`${BASE_PATH}/:channelId/archive`, { channelId }),

  /** Raw path for buildEndpointWithQuery */
  basePath: () => BASE_PATH,
} as const;

export default notificationEndpoints;
